<script setup lang="ts">
import { ref, watch } from 'vue'

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/ui'

const props = defineProps<{
  defaultOpen?: boolean
  title?: string
  description?: string
  classNames?: string
  headerClassNames?: string
  titleClassNames?: string
  descriptionClassNames?: string
  disableEscBgClick?: boolean
  callback?: () => void
}>()

const emits = defineEmits<{
  (event: 'update:open', value: boolean): void
}>()

const isOpen = ref(false)

watch(
  () => props.defaultOpen,
  value => {
    if (value) isOpen.value = value
  },
  { immediate: true }
)

const handleOpen = (value: boolean) => {
  if (!value && props.callback) {
    props.callback()
  }
  emits('update:open', value)
}

const onClose = () => {
  if (props.callback) {
    props.callback()
  }
  isOpen.value = false
}
</script>

<template>
  <Dialog v-model:open="isOpen" @update:open="handleOpen">
    <DialogTrigger as-child>
      <slot />
    </DialogTrigger>
    <DialogContent :class="classNames" :disable-esc-bg-click="disableEscBgClick">
      <DialogHeader :class="headerClassNames">
        <DialogTitle :class="titleClassNames">
          <slot name="title-icon" />
          {{ title }}
        </DialogTitle>
        <DialogDescription :class="descriptionClassNames">
          <slot name="description" />
          {{ description }}
        </DialogDescription>
      </DialogHeader>

      <slot name="content" :is-open="isOpen" :close="onClose" />
    </DialogContent>
  </Dialog>
</template>
